import axios, { AxiosInstance } from "axios";
import { showIpBanNotice } from "./ipBanNotice";

const api2: AxiosInstance = axios.create({
  baseURL: "",
  withCredentials: true,
  // Axios preserves JSON types for objects and detects FormData/URLSearchParams.
});

api2.interceptors.response.use(
  response => response,
  error => {
    showIpBanNotice(error);
    return Promise.reject(error);
  },
);

export default api2;
